// organizationStore fetch states are used by multiple notification UIs, but in order to properly display notifications, we need
// to delay the deletion of the success/failure states or we'll never get any notifications showing up
import {useContext, useEffect, useState} from "react";
import {entries, has, values} from "mobx";
import {StoreContext} from "../stores/StoreLoader";
import {FetchState, fetchState} from "../stores/OrganizationStore";

export default function useDelayedFetchStates(delay: number = 5000) {
    const {organizationStore} = useContext(StoreContext);
    const [delayedFetchStates, setDelayedFetchStates] = useState<{[k: string]: FetchState}>({});

    useEffect(() => {
        // when updates happen, we want to show them, but when states are removed we want to preserve them for a short time
        let t;
        entries(organizationStore.fetchStates).forEach(([k, v]) => {
            setDelayedFetchStates(p => ({
                ...p,
                [k]: v,
            }))
        });
        for (let k in delayedFetchStates) {
            if (delayedFetchStates.hasOwnProperty(k) && !has(organizationStore.fetchStates, k)) {
                // it's important to create a new object here so observers react
                t = setTimeout(() => setDelayedFetchStates(p => Object.fromEntries(Array.from(Object.entries(p)).filter(([key]) => key !== k))), delay);
            }
        }

        return () => clearTimeout(t);
    }, [JSON.stringify(values(organizationStore.fetchStates).map(f => f.value))])

    return delayedFetchStates;
}
